import {
  Directive,
  ElementRef,
  HostBinding,
  Input, NgZone,
  OnDestroy, OnInit,
  Renderer2
} from '@angular/core';
import {
  isInteger,
  toInteger,
  includes,
  isEqual,
  isObject,
  isArray,
  toArray
} from 'lodash';
import {fromEvent, merge, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {toBoolean} from '../core/convert';

function isAddClass(isReq: any = true, forbid = false): boolean {
  return forbid ? false : (isReq === '' || (isReq !== false && isReq !== 'false'));
}

export interface JdBreakpoint {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
}

export interface JdBreakpointNum {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
}

function getBreakpoint(width: number) {
  return {
    xs: width <= 479.98,
    sm: width <= 767.98 && width >= 480,
    md: width <= 991.98 && width >= 768,
    lg: width <= 1199.98 && width >= 992,
    xl: width <= 1599.98 && width >= 1200,
    xxl: width >= 1600
  };
}

export interface ClassPool {
  key: string;
  classPrefix: string;
  num: number;
}


@Directive({
  selector: `jd-col[jd-col-obj],[col][jd-col-obj],jd-col[jd-offset-obj],[col][jd-offset-obj],jd-col[jd-pull-obj],[col][jd-pull-obj],jd-col[jd-push-obj],[col][jd-push-obj],jd-col[jd-align-self-start],[col][jd-align-self-start], jd-col[jd-align-self-center],[col][jd-align-self-center], jd-col[jd-align-self-end],[col][jd-align-self-end],jd-col[jd-align-self-stretch],[col][jd-align-self-stretch],jd-col[jd-align-self-baseline],[col][jd-align-self-baseline],jd-col[jd-col-auto],[col][jd-col-auto],jd-col[jd-cols],[col][jd-cols], jd-col[jd-col-sm],[col][jd-col-sm],jd-col[jd-push],[col][jd-push],jd-col[jd-pull],[col][jd-pull],jd-col[jd-pull-sm],[col][jd-pull-sm],jd-col[jd-push-sm],[col][jd-push-sm], jd-col[jd-offset],[col][jd-offset],jd-col[jd-push-xxl],[col][jd-push-xxl],jd-col[jd-offset-sm],[col][jd-offset-sm],jd-col[jd-col-md],[col][jd-col-md],jd-col[jd-col-xxl],[col][jd-col-xxl],jd-col[jd-pull-md],[col][jd-pull-md],jd-col[jd-offset-md],[col][jd-offset-md],jd-col[jd-pull-md],[col][jd-pull-md], jd-col[jd-col-lg],[col][jd-col-lg],jd-col[jd-pull-lg],[col][jd-pull-lg],jd-col[jd-offset-lg],[col][jd-offset-lg],jd-col[jd-pull-lg],[col][jd-pull-lg],jd-col[jd-col-xl],[col][jd-col-xl], jd-col[jd-pull-xl],[col][jd-pull-xl],jd-col[jd-offset-xl],[col][jd-offset-xl],jd-col[jd-pull-xl],[col][jd-pull-xl],jd-col[jd-col-xs],[col][jd-col-xs],jd-col[jd-pull-xs],[col][jd-pull-xs],jd-col[jd-offset-xs],[col][jd-offset-xs],jd-col[jd-offset-xxl],[col][jd-offset-xxl],jd-col[jd-pull-xs],[col][jd-pull-xs],jd-col[jd-pull-xxl],[col][jd-pull-xxl],jd-col[jd-hide-xl],[col][jd-hide-xl],jd-col[jd-hide-xs],[col][jd-hide-xs],jd-col[jd-hide-sm],[col][jd-hide-sm], jd-col[jd-hide-lg],[col][jd-hide-lg],jd-col[jd-hide-md],[col][jd-hide-md],jd-col[jd-hide-xxl],[col][jd-hide-xxl],jd-col[jd-clear],[col][jd-clear]`
})
export class JdColExpDirective implements OnDestroy, OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  DOMContentLoadedEventSetTime = null;
  private _alignSelfStart = false;
  private _alignSelfCenter = false;
  private _alignSelfEnd = false;
  private _alignSelfStretch = false;
  private _alignSelfBaseline = false;
  private _hideXs = false;
  private _hideSm = false;
  private _hideMd = false;
  private _hideLg = false;
  private _hideXl = false;
  private _colAuto = false;
  private _isByDepWidthDoResponsive = false;
  private _parentEl: HTMLElement;
  // TODO _parentWidth is not currently in use
  private _parentWidth: number;
  private _filterBreakpoint = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
  private _breakpoint: JdBreakpoint;
  private _colClassPool: Array<ClassPool> = [];
  private _hideClassPool: Array<ClassPool> = [];
  private _pullClassPool: Array<ClassPool> = [];
  private _pushClassPool: Array<ClassPool> = [];
  private _offsetClassPool: Array<ClassPool> = [];

  private _classArr: string[] = [];

  private _forbid = false;

  @Input('jd-clear')
  set clear(value: boolean) {
    const _isAddClass = isAddClass(value);
    if (_isAddClass) {
      this._forbid = true;
    } else {
      this._forbid = false;
    }
  }

  set breakpoint(bp: JdBreakpoint) {
    this._breakpoint = bp;
    this._updateClass();
  }

  get breakpoint(): JdBreakpoint {
    return this._breakpoint;
  }

  private _resizeChange$ = new Subject();

  /* æ¯å¦ä¾èµç¶åç´ çå®½åº¦æ¥è¿è¡ååºå¼ */
  @Input()
  set isByDepWidthDoResponsive(value: boolean) {
    this._isByDepWidthDoResponsive = toBoolean(value);
  }

  @Input()
  set parentElOrWidth(value: HTMLElement) {
    if (this._isByDepWidthDoResponsive) {
      if (value instanceof HTMLElement) {
        this._parentEl = value;
        this.DOMContentLoadedEvent(value).then(() => {
          this._parentWidth = value.clientWidth;
          this.breakpoint = getBreakpoint(value.clientWidth);
        });
      }
    }
  }

  @Input('jd-col-sm')
  set colSm(value: any) {
    this._validNumAndInteger('jd-col-sm', value, 'col-sm', [1, 24]);
  }

  @Input('jd-col-xxl')
  set colXxl(value: any) {
    this._validNumAndInteger('jd-col-xxl', value, 'col-xxl', [1, 24]);
  }

  @Input('jd-col-obj')
  set colObj(value: JdBreakpointNum) {
    this._validObj(value, 'col', [1, 24]);
  }

  @Input('jd-col-lg')
  set colLg(value: any) {
    this._validNumAndInteger('jd-col-lg', value, 'col-lg', [1, 24]);
  }

  @Input('jd-col-md')
  set colMd(value: any) {
    this._validNumAndInteger('jd-col-md', value, 'col-md', [1, 24]);
  }

  @Input('jd-col-xl')
  set colXl(value: any) {
    this._validNumAndInteger('jd-col-xl', value, 'col-xl', [1, 24]);
  }

  @Input('jd-col-xs')
  set colXs(value: any) {
    this._validNumAndInteger('jd-col-xs', value, 'col-xs', [1, 24]);
  }

  @Input('jd-push')
  set push(value: any) {
    this._validNumAndInteger('jd-push', value, 'push', [0, 24]);
  }

  @Input('jd-push-sm')
  set pushSm(value: any) {
    this._validNumAndInteger('jd-push-sm', value, 'push-sm', [0, 24]);
  }

  @Input('jd-push-xxl')
  set pushXxl(value: any) {
    this._validNumAndInteger('jd-push-xxl', value, 'push-xxl', [0, 24]);
  }

  @Input('jd-push-obj')
  set pushObj(value: JdBreakpointNum) {
    this._validObj(value, 'push', [0, 24]);
  }

  @Input('jd-push-md')
  set pushMd(value: any) {
    this._validNumAndInteger('jd-push-md', value, 'push-md', [0, 24]);
  }

  @Input('jd-push-xl')
  set pushXl(value: any) {
    this._validNumAndInteger('jd-push-xl', value, 'push-xl', [0, 24]);
  }

  @Input('jd-push-xs')
  set pushXs(value: any) {
    this._validNumAndInteger('jd-push-xs', value, 'push-xs', [0, 24]);
  }

  @Input('jd-push-lg')
  set pushLg(value: any) {
    this._validNumAndInteger('jd-push-lg', value, 'push-lg', [0, 24]);
  }

  @Input('jd-pull')
  set pull(value: any) {
    this._validNumAndInteger('jd-pull', value, 'pull', [0, 24]);
  }

  @Input('jd-pull-obj')
  set pullObj(value: JdBreakpointNum) {
    this._validObj(value, 'pull', [0, 24]);
  }

  @Input('jd-pull-md')
  set pullMd(value: any) {
    this._validNumAndInteger('jd-pull-md', value, 'pull-md', [0, 24]);
  }

  @Input('jd-pull-xxl')
  set pullXxl(value: any) {
    this._validNumAndInteger('jd-pull-xxl', value, 'pull-xxl', [0, 24]);
  }

  @Input('jd-pull-lg')
  set pullLg(value: any) {
    this._validNumAndInteger('jd-pull-lg', value, 'pull-lg', [0, 24]);
  }

  @Input('jd-pull-xl')
  set pullXl(value: any) {
    this._validNumAndInteger('jd-pull-xl', value, 'pull-xl', [0, 24]);
  }

  @Input('jd-pull-xs')
  set pullXs(value: any) {
    this._validNumAndInteger('jd-pull-xs', value, 'pull-xs', [0, 24]);
  }

  @Input('jd-pull-sm')
  set pullSm(value: any) {
    this._validNumAndInteger('jd-pull-sm', value, 'pull-sm', [0, 24]);
  }

  @Input('jd-offset')
  set offset(value: any) {
    this._validNumAndInteger('jd-offset', value, 'offset', [1, 23]);
  }

  @Input('jd-offset-obj')
  set offsetObj(value: JdBreakpointNum) {
    this._validObj(value, 'offset', [0, 24]);
  }

  @Input('jd-offset-md')
  set offsetMd(value: any) {
    this._validNumAndInteger('jd-offset-md', value, 'offset-md', [0, 23]);
  }

  @Input('jd-offset-xxl')
  set offsetXxl(value: any) {
    this._validNumAndInteger('jd-offset-xxl', value, 'offset-xxl', [0, 23]);
  }

  @Input('jd-offset-lg')
  set offsetLg(value: any) {
    this._validNumAndInteger('jd-offset-lg', value, 'offset-lg', [0, 23]);
  }

  @Input('jd-offset-xl')
  set offsetXl(value: any) {
    this._validNumAndInteger('jd-offset-xl', value, 'offset-xl', [0, 23]);
  }

  @Input('jd-offset-xs')
  set offsetXs(value: any) {
    this._validNumAndInteger('jd-offset-xs', value, 'offset-xs', [0, 23]);
  }

  @Input('jd-offset-sm')
  set offsetSm(value: any) {
    this._validNumAndInteger('jd-offset-sm', value, 'offset-sm', [1, 23]);
  }

  @Input('jd-cols')
  set col(value: any) {
    this._validNumAndInteger('jd-cols', value, 'col');
  }

  @HostBinding('class.col-auto')
  @Input('jd-col-auto')
  set colAuto(value: boolean) {
    this._colAuto = isAddClass(value, this._forbid);
  }

  get colAuto() {
    this._classArr.push('col-auto');
    return this._colAuto;
  }

  @HostBinding('class.align-self-baseline')
  @Input('jd-align-self-baseline')
  set alignSelfBaseline(value: boolean) {
    this._alignSelfBaseline = isAddClass(value, this._forbid);
  }

  get alignSelfBaseline() {
    this._classArr.push('align-self-baseline');
    return this._alignSelfBaseline;
  }

  @HostBinding('class.hide-xs')
  @Input('jd-hide-xs')
  set hideXs(value: any) {
    this._addClassPoolFn(value, 'hide-xs');
    this._hideXs = isAddClass(this._isByDepWidthDoResponsive ? false : value, this._forbid);
  }

  get hideXs() {
    this._classArr.push('hide-xs');
    return this._hideXs;
  }

  @HostBinding('class.hide-sm')
  @Input('jd-hide-sm')
  set hideSm(value: any) {
    this._addClassPoolFn(value, 'hide-sm');
    this._hideSm = isAddClass(this._isByDepWidthDoResponsive ? false : value, this._forbid);
  }

  get hideSm() {
    this._classArr.push('hide-sm');
    return this._hideSm;
  }

  @HostBinding('class.hide-md')
  @Input('jd-hide-md')
  set hideMd(value: any) {
    this._addClassPoolFn(value, 'hide-md');
    this._hideMd = isAddClass(this._isByDepWidthDoResponsive ? false : value, this._forbid);
  }

  get hideMd() {
    this._classArr.push('hide-md');
    return this._hideMd;
  }

  @HostBinding('class.hide-lg')
  @Input('jd-hide-lg')
  set hideLg(value: any) {
    this._addClassPoolFn(value, 'hide-lg');
    this._hideLg = isAddClass(this._isByDepWidthDoResponsive ? false : value, this._forbid);
  }

  get hideLg() {
    this._classArr.push('hide-lg');
    return this._hideLg;
  }

  @HostBinding('class.hide-xl')
  @Input('jd-hide-xl')
  set hideXl(value: any) {
    this._addClassPoolFn(value, 'hide-xl');
    this._hideXl = isAddClass(this._isByDepWidthDoResponsive ? false : value, this._forbid);
  }

  get hideXl() {
    this._classArr.push('hide-xl');
    return this._hideXl;
  }

  @HostBinding('class.align-self-stretch')
  @Input('jd-align-self-stretch')
  set alignSelfStretch(value: boolean) {
    this._alignSelfStretch = isAddClass(value, this._forbid);
  }

  get alignSelfStretch() {
    this._classArr.push('align-self-stretch');
    return this._alignSelfStretch;
  }

  @HostBinding('class.align-self-end')
  @Input('jd-align-self-end')
  set alignSelfEnd(value: boolean) {
    this._alignSelfEnd = isAddClass(value, this._forbid);
  }

  get alignSelfEnd() {
    this._classArr.push('align-self-end');
    return this._alignSelfEnd;
  }

  @HostBinding('class.align-self-center')
  @Input('jd-align-self-center')
  set alignSelfCenter(value: boolean) {
    this._alignSelfCenter = isAddClass(value, this._forbid);
  }

  get alignSelfCenter() {
    this._classArr.push('align-self-center');
    return this._alignSelfCenter;
  }

  @HostBinding('class.align-self-start')
  @Input('jd-align-self-start')
  set alignSelfStart(value: boolean) {
    this._alignSelfStart = isAddClass(value, this._forbid);
  }

  get alignSelfStart() {
    this._classArr.push('align-self-start');
    return this._alignSelfStart;
  }

  _validNumAndInteger(
    key: string,
    value: any,
    classPrefix: string,
    range: [number, number] = [0, 24]
  ) {
    if (value === false || value === 'false' || value === '') {
      return;
    }
    if (!isInteger(+value)) {
      throw Error(`@input() ${key} must to be Integer`);
    }
    const _num = toInteger(value);
    if (_num > range[1] || _num < range[0]) {
      throw Error(
        `@input() ${key} must to be Integer and  in (${range[0]}, ${range[1]})`
      );
    }
    const className =
      _num === 0
        ? `${classPrefix === 'col' ? classPrefix : ''}`
        : `${classPrefix}-${_num}`;

    // æ¯å¦ classPrefix å­å¨ (sm)|(xs)|(md)|(lg)|(xl)|(xxl)
    const _isExitBreakpointInClassPrefix = /(sm)|(xs)|(md)|(lg)|(xl)|(xxl)/.test(
      classPrefix
    );

    // åªæå¨éè¦ä¾èµç¶åç´ çå®½æ¥è¿è¡ååºå¼ && classPrefix å­å¨ (sm)|(xs)|(md)|(lg)|(xl)|(xxl) çæ¶å
    if (this._isByDepWidthDoResponsive && _isExitBreakpointInClassPrefix) {
      this._addClassPoolFn(value, classPrefix, _num);
    } else if (!this._forbid) {
      this._classArr.push(className);
      this._addClass(className, true);
    }
  }

  _clearClass(filter: string[]) {
    let _classList: string[] = toArray(this._el.nativeElement.classList);
    _classList = isArray(_classList) ? _classList.filter(value => !includes(filter, value)) : [];
    if (_classList.length) {
      this._el.nativeElement.class = '';
      _classList.forEach(value => this._addClass(value, true));
    }
  }

  _validObj(
    bk: JdBreakpointNum,
    key: 'col' | 'pull' | 'push' | 'offset',
    range: [number, number] = [0, 24]
  ) {
    if (!bk || !isObject(bk)) {
      return;
    }
    for (const bkKey in bk) {
      if (bk.hasOwnProperty(bkKey)) {
        this._validNumAndInteger(
          `jd-${key}-${bkKey}`,
          bk[bkKey],
          `${key}-${bkKey}`,
          range
        );
      }
    }
  }

  _addClass(className: string, isReq = true) {
    if (isReq !== false) {
      this._renderer.addClass(this._el.nativeElement, className);
    }
  }

  _removeClass(className: string[]) {
    className.forEach(value => {
      this._renderer.removeClass(this._el.nativeElement, value);
    });
  }

  _addClassPoolFn(value, classPrefix: string, num?: number) {
    if (this._isByDepWidthDoResponsive && !this._forbid) {
      const _poolMap = {
        col: this._colClassPool,
        hide: this._hideClassPool,
        pull: this._pullClassPool,
        push: this._pushClassPool,
        offset: this._offsetClassPool
      };
      classPrefix.replace(/(col)|(hide)|(pull)|(push)|(offset)/, key => {
        _poolMap[key].push({
          classPrefix,
          num: num ? num : null,
          key: key
        });
        return '';
      });
    }
  }

  _updateClassU(pool: Array<ClassPool> = []) {
    const _removeClass = [],
      _restRemoveClass = [];
    let off = false;
    pool.forEach(value => {
      const _prefix = value.classPrefix.split('-'),
        _num = value.num || value.num === 0 ? '-' + value.num : '',
        _classPrefix =
          _prefix[1] && includes(this._filterBreakpoint, _prefix[1])
            ? _prefix[1]
            : null;
      if (this._breakpoint[_classPrefix]) {
        const _className = `jd-${value.classPrefix}${_num}`;
        this._removeClass(_removeClass);
        this._classArr.push(_className);
        this._addClass(_className, true);
        off = true;
      } else {
        _removeClass.push(`jd-${_prefix[0]}-${_prefix[1]}${_num}`);
        // ç»§ç»­æ¶éå©ä½æªç§»é¤çclass
        if (off) {
          _restRemoveClass.push(`jd-${_prefix[0]}-${_prefix[1]}${_num}`);
        }
      }
    });
    if (_restRemoveClass.length) {
      this._removeClass(_restRemoveClass);
    }
    if (!off) {
      this._removeClass(_removeClass);
    }
  }

  constructor(private _el: ElementRef, private _renderer: Renderer2, private _ngZone: NgZone) {
    this._resizeChange$
      .pipe(
        debounceTime(50),
        takeUntil(this._unsubscribe$)
      ).subscribe(() => {
      const _newBreakpoint = getBreakpoint(this._parentEl.clientWidth);
      // ä¼å diff
      if (!isEqual(this.breakpoint, _newBreakpoint)) {
        this.breakpoint = _newBreakpoint;
      }
    });
    this._ngZone.runOutsideAngular(() => {
      merge(fromEvent(window, 'resize'))
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(() => {
          if (this._isByDepWidthDoResponsive) {
            this._resizeChange$.next();
          }
        })
    })
  }

  ngOnInit() {
    if (this._forbid) {
      this._clearClass(this._classArr);
    }
  }

  _updateClass() {
    if (!this._breakpoint) {
      return;
    }
    const _pool = [
      this._colClassPool,
      this._hideClassPool,
      this._pullClassPool,
      this._pushClassPool,
      this._offsetClassPool
    ];

    _pool.forEach(value => {
      if (value.length) {
        this._updateClassU(value);
      }
    });
  }

  DOMContentLoadedEvent(value: HTMLElement): Promise<number> {
    return new Promise(resolve => {
      if (!this.DOMContentLoadedEventSetTime) {
        this.DOMContentLoadedEventSetTime = setTimeout(() => {
          if (value.clientWidth) {
            clearTimeout(this.DOMContentLoadedEventSetTime);
            this.DOMContentLoadedEventSetTime = null;
            resolve(value.clientWidth);
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
